import Modal from 'bootstrap/js/src/modal.js';

class Confirm {
  constructor(element, options = {}) {
    this.element = element;

    const defaults = {
      'id': this.generateRandomId(),
      'icon': this.getIconFromElement(),
      'title': this.getTitleFromElement(),
      'message': this.getMessageFromElement(),
      'confirmButtonLabel': this.getConfirmButtonLabelFromElement(),
      'confirmButtonType': this.getConfirmButtonTypeFromElement(),
    };

    this.options = Object.assign({}, defaults, options);

    this.addModalToDom();
    this.registerEventListener();
  }

  registerEventListener() {
    this.element.addEventListener('click', (event) => {
      event.preventDefault();
      this.modal.show();
    });
  }

  addModalToDom() {
    document.body.insertAdjacentHTML('beforeEnd', `
      <div id="${this.options.id}" class="modal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h2 class="h3 modal-title text-body">
                <i class="${this.options.icon}"></i>
                ${this.options.title}
              </h2>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              ${this.options.message}
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-${this.options.confirmButtonType}" data-action="confirm">${this.options.confirmButtonLabel}</button>
            </div>
          </div>
        </div>
      </div>
    `);

    this.initializeModal();
    this.registerConfirmButtonEvent();
    this.registerModalEventListener();
  }

  registerModalEventListener() {
    document.querySelector(`#${this.options.id}`).addEventListener('hidden.bs.modal', () => {
      this.element.focus();
    });
  }

  registerConfirmButtonEvent() {
    const url = this.element.href;
    const confirmButton = document.querySelector(`#${this.options.id} button[data-action="confirm"]`);

    confirmButton.addEventListener('click', () => {
      window.location.href = url;
    });
  }

  initializeModal() {
    this.modal = new Modal(document.querySelector(`#${this.options.id}`));
  }

  generateRandomId() {
    const letters = 'abcdefghijklmnopqrstuvwxyz';
    const randomLetter = letters.charAt(Math.floor(Math.random() * letters.length));
    return randomLetter + (Math.random() + 1).toString(36).substring(2);
  }

  getIconFromElement() {
    const icon = this.element.dataset.icon;
    return icon ? icon : 'fa-solid fa-triangle-exclamation';
  }

  getTitleFromElement() {
    const title = this.element.dataset.title;
    return title ? title : 'Warning';
  }

  getMessageFromElement() {
    const message = this.element.dataset.message;
    return message ? message : 'Are you sure you would like to continue?';
  }

  getConfirmButtonLabelFromElement() {
    const confirmButtonLabel = this.element.dataset.confirmButtonLabel;
    return confirmButtonLabel ? confirmButtonLabel : 'Continue';
  }

  getConfirmButtonTypeFromElement() {
    const confirmButtonType = this.element.dataset.confirmButtonType;
    return confirmButtonType ? confirmButtonType : 'primary';
  }
}

export default Confirm;
